'use client';
import AutoSliderNeupos from '@/components/AutoSliderNeupos';
import { Fragment } from 'react';
import Heading from '../../../textContent/neupos/Data1.json';
import NeuposHero from '@/components/NeuposHero';
import VideoTextCard from '@/components/VideoTextCard';
import cardData from '../../../textContent/neupos/Card1.json';
import { motion } from 'framer-motion';
import sliderData from '../../../textContent/neupos/Slider1.json';

const page = () => {
    const { hero } = Heading;

    // FadeUp animation variant
    const fadeUp = {
        hidden: { opacity: 0, y: 40 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: 'easeOut',
            },
        },
    };

    return (
        <Fragment>
            {/* Hero Section */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="pt-10 md:pt-8"
            >
                <NeuposHero {...hero} />
            </motion.div>

            <motion.section
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="py-12 md:py-20"
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl md:text-4xl font-extrabold text-center text-gray-900">
                        {sliderData.title}
                    </h2>

                    <p className="text-center text-gray-600 mt-3 mb-12 max-w-3xl mx-auto">
                        {sliderData.caption}
                    </p>

                    <AutoSliderNeupos
                        images={sliderData.images}
                        speed={sliderData.sliderSettings.speed}
                        direction={sliderData.sliderSettings.direction}
                        gradient={sliderData.sliderSettings.gradient}
                        gradientWidth={sliderData.sliderSettings.gradientWidth}
                    />
                </div>
            </motion.section>

            {/* VideoTextCard Section 1 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={cardData.card1} />
            </motion.div>

            {/* VideoTextCard Section 2 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={cardData.card2} />
            </motion.div>

            {/* VideoTextCard Section 3 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={cardData.card3} />
            </motion.div>
        </Fragment>
    );
};

export default page;
